"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviderChainId = void 0;
/**
 * Obtains the chain id through a provider.
 * Different providers might return the chain id as a hex or a number.
 * This function abtracts the logic in order to always obtain the chain id as a number from any given provider.
 * @param provider - The provider used to obtain the chain id
 * @returns A number representing the chain id, Eg: 80001 for Mumbai, 137 for Matic Mainnet
 */
function getProviderChainId(provider) {
    return __awaiter(this, void 0, void 0, function* () {
        const providerChainId = (yield provider.request({
            method: 'eth_chainId',
            params: []
        }));
        let chainId;
        if (typeof providerChainId === 'string') {
            chainId = parseInt(providerChainId, 16);
        }
        else {
            chainId = providerChainId;
        }
        return chainId;
    });
}
exports.getProviderChainId = getProviderChainId;
//# sourceMappingURL=getProviderChainId.js.map